var React = require('react');
import PropTypes from 'prop-types';

import { datastoreComponentConnect } from './DatastoreComponentMixin.jsx';

class StateCell extends React.Component {
    static contextTypes = {
        t: PropTypes.func.isRequired
    }

    render() {
        var value = this.props.data;
        var disabled = false, checked = false;
        if (value && this.props.data.v !== undefined) {
            // Disable if data is being stored right now
            disabled = ~~value['new'];
            if (value['new'] !== undefined) {
                checked = ~~value['new'];
            } else {
                checked = ~~value.v;
            }
        };

        return (
            <td><div className={ checked ? "statecell active" : "statecell inactive"}>
                {this.context.t(checked ? 'general.state_active' : 'general.state_inactive')}
            </div></td>
        );
    }
}

export default datastoreComponentConnect(StateCell);

